import {z} from 'zod';

import {TeachnowZoomAccountSchema} from '../firebase/documents/teachnowZoomAccounts';

/**
 * Callable function that returns every Zoom account in the TeachNow allocator
 * pool. Access is gated server-side to admins of any active course because the
 * `zoomAllocator/teachnow/accounts` collection has no Firestore security rules
 * permitting client reads.
 */
export const LIST_TEACHNOW_ZOOM_ACCOUNTS_FUNCTION =
  'listteachnowzoomaccounts' as const;

/** Response shape for the {@link LIST_TEACHNOW_ZOOM_ACCOUNTS_FUNCTION} callable. */
export const ListTeachnowZoomAccountsResponseSchema = z.object({
  /**
   * Every account in the TeachNow pool, including accounts where `isActive` is
   * false. Inactive accounts are still treated as conflicts by the admin Zoom
   * editor so that debug accounts don't silently overlap with a course's
   * `sectionZoomAccounts`.
   */
  accounts: z.array(TeachnowZoomAccountSchema),
});

export type ListTeachnowZoomAccountsResponse = z.infer<
  typeof ListTeachnowZoomAccountsResponseSchema
>;
